import React, { useEffect, useState } from "react";
import "./FestivalType.scss";
import Modal from "@mui/material/Modal";
import { useNavigate, useSearchParams } from "react-router-dom";
import { PropertyApi } from "../../../../utils/api/Property";
import { TemplatesApi } from "../../../../utils/api/Templates";
import { CommonEnums } from "../../../../enums/common.enums";
import toast from "react-hot-toast";
import SearchIcon from "../../../../components/icons/SearchIcon";

const FestivalType: React.FC = () => {
  const [festivalTypes, setFestivalTypes] = useState<any[]>([]);
  const [loadingFestivalTypes, setLoadingFestivalTypes] = useState(true);

  const [processingModalOpen, setProcessingModalOpen] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const fetchFestivalTypes = async () => {
    try {
      setLoadingFestivalTypes(true);

      const res = await TemplatesApi.getFestivalTypes({
        search: "",
        page: 1,
        limit: 200,
        created_at: "desc",
      });

      const list = res?.data?.data?.docs || [];
      setFestivalTypes(list);
    } catch (err) {
      console.error("❌ Error loading festival types", err);
      toast.error("Failed to load festival types");
    } finally {
      setLoadingFestivalTypes(false);
    }
  };

  useEffect(() => {
    fetchFestivalTypes();
  }, []);

  const handleCreateFestivalPost = async (slug: string) => {
    setProcessingModalOpen(true);
    setIsProcessing(true);

    try {
      const payload = { festival_type: slug };
      const existingId = searchParams.get("festival_post_id");

      let res;
      if (existingId) {
        res = await PropertyApi.updateFestivalPost(payload, existingId);
      } else {
        res = await PropertyApi.createFestivalPost(payload);
      }

      const data = res?.data?.data;

      if (data?._id) {
        setSearchParams((prev) => {
          const next = new URLSearchParams(prev);
          next.set("festival_post_id", data._id);
          next.set("festival_type", slug);
          next.set("step", CommonEnums.festivalPostTabs.select_template.key);
          return next;
        });
      } else {
        toast.error("Something went wrong while saving the festival post.");
      }
    } catch (err) {
      console.error("❌ Error saving festival post:", err);
      toast.error("Error while saving festival post");
    } finally {
      setIsProcessing(false);
      setProcessingModalOpen(false);
    }
  };

  return (
    <div className="festival-type-tab">
      <div className="section">
        <p className="section-description">Select Festival Type</p>

        <div className="festival-search-wrapper">
          <div className="festival-search-box">
            <SearchIcon />
            <input
              type="text"
              placeholder="Search Festival"
              className="festival-search-input"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        </div>

        <div className="button-group">
          {!loadingFestivalTypes &&
            festivalTypes
              .filter((item) =>
                item.name.toLowerCase().includes(searchQuery.toLowerCase())
              )
              .map((item) => (
                <button
                  key={item.slug}
                  className="review-type-btn"
                  onClick={() => handleCreateFestivalPost(item.slug)}
                >
                  {item.name}
                </button>
              ))}

          {!loadingFestivalTypes &&
            festivalTypes.filter((item) =>
              item.name.toLowerCase().includes(searchQuery.toLowerCase())
            ).length === 0 && (
              <p className="no-results-text">No festival found</p>
            )}
        </div>
      </div>

      <Modal
        open={processingModalOpen}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") setProcessingModalOpen(false);
        }}
        aria-labelledby="processing-modal"
        className="add-property-modal styled-modal"
        disableEscapeKeyDown
      >
        <div className="modal-center-wrapper">
          <div className="loading-content-wrapper">
            {isProcessing && (
              <div className="loading-container">
                <div className="spinner" />
                <p className="loading-text">
                  Processing your request
                  <br />
                  Please wait...
                </p>
              </div>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default FestivalType;
